import classNames from 'classnames';
import FormControl from './FormControl';
import FormError from './FormError';
import FormFieldset from './FormFieldset';
import FormHint from './FormHint';
import FormLabel from './FormLabel';
import FormRow from './FormRow';
import React from 'react';
import PropTypes from 'prop-types';

export default function Form({
    children,
    className,
    ...props
}) {
    const classes = classNames(className);
    return (
        <form {...props} className={classes}>
            {children}
        </form>
    );
}

Form.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

Form.Control = FormControl;
Form.Error = FormError;
Form.Fieldset = FormFieldset;
Form.Hint = FormHint;
Form.Label = FormLabel;
Form.Row = FormRow;
